import { useCallback, useContext, useEffect } from 'react';

import { ConsortiumPaymentMethods, Summary } from '..';
import { Form } from '../../../../../../../../../shared/components';
import {
  GenericDataFormContext,
  QUOTATION_BUTTON,
  QuotationInfoContext,
  QuotationStep,
  QuotationStepButtons,
} from '../../../../../shared';
import { Tabs } from '@hdi-seguros/web-components.tabs';

import { StepThreeFormContext } from '../../contexts/StepThreeForm';
import {
  generateInputID,
  getCoverageAndActivityKeyByID,
} from '../../../../../AP/Steps/StepThree/components/Quotation/utils';

export const ConsortiumQuotation = () => {
  const { allCoveragesPerPlan, setFormValues } = useContext(GenericDataFormContext);
  const {
    activeTab,
    canCreateTabThree,
    clearPrimaFieldsOnFormChange,
    createTabs,
    handlerOnClick,
    labelButton,
    quotationResponse,
    quotationTabs,
    setActiveTab,
    setLabelButton,
    stepThreeConsortiumQuotationForm,
  } = useContext(StepThreeFormContext);
  const { setCurrentStep, savedQuotation } = useContext(QuotationInfoContext);

  const handlePressTab = (activeTab: string) => setActiveTab(activeTab);

  const onPressBackButton = useCallback(async () => {
    setFormValues(stepThreeConsortiumQuotationForm.getFieldsValue());
    if (quotationResponse) setLabelButton(QUOTATION_BUTTON.RECOTIZAR);
    setCurrentStep(QuotationStep.TWO);
  }, [
    setCurrentStep, 
    setLabelButton, 
    quotationResponse,
    setFormValues,
    stepThreeConsortiumQuotationForm,
  ]);

  const onChangeForm = useCallback(
    (changedFields: any[]) => {
      if (quotationResponse) {
        setLabelButton(QUOTATION_BUTTON.RECOTIZAR);
        clearPrimaFieldsOnFormChange();
      }

      const nameOfFieldChanged: string = changedFields[0].name[0];
      const valueChanged = changedFields[0].value;

      const { activityKey, id } =
        getCoverageAndActivityKeyByID(nameOfFieldChanged);

      const tabKey = activityKey.split('-')[2];

      const planSelected = stepThreeConsortiumQuotationForm.getFieldValue(
        `plan-tab-${tabKey}`
      );

      const allCoveragesByTab = allCoveragesPerPlan.find(
        (el) => String(el.plan as string) === String(planSelected)
      )?.coverages;

      //* Verifico si la cobertura que modifique es alguna de las que dependen otras.
      const coverageCode = allCoveragesByTab?.find(
        (el) => el.id === id
      )?.codigo;

      if (coverageCode) {
        //* Tengo que verificar ahora si en las coberturas disponibles, alguna de ellas tiene relación con este coverageCode.
        const relatedCoverages = allCoveragesByTab?.filter(
          (el) => el.codigoCoberturaRelacionada === coverageCode
        );

        //* Ahora tendría que setear en el formulario correspondiente, es decir, cada cobertura en la actividad correspondiente.
        relatedCoverages.forEach(({ id, porcentajeSumaAsegegurada }) => {
          const checkboxName = generateInputID(id, activityKey, 'checkbox');
          if (stepThreeConsortiumQuotationForm.getFieldValue(checkboxName)) {
            const inputName = generateInputID(id, activityKey);

            stepThreeConsortiumQuotationForm.setFieldValue(
              inputName,
              Math.round(
                valueChanged * (Number(porcentajeSumaAsegegurada) / 100)
              )
            );
          }
        });
      }
    },
    [
      setLabelButton,
      allCoveragesPerPlan,
      stepThreeConsortiumQuotationForm,
      quotationResponse,
      clearPrimaFieldsOnFormChange,
    ]
  );

  useEffect(() => {
    if (!savedQuotation || !canCreateTabThree) createTabs();
  }, [createTabs]);

  return (
    <>
      <Form
        formProps={{
          form: stepThreeConsortiumQuotationForm,
          name: 'quotation-consortium-tab-form',
          onFieldsChange: onChangeForm,
        }}
      >
        <Tabs
          handlePressTab={handlePressTab}
          activeKey={activeTab}
          items={quotationTabs}
        />
      </Form>

      {quotationResponse && (
        <>
          <ConsortiumPaymentMethods />

          <Summary />
        </>
      )}

      <QuotationStepButtons
        label={labelButton}
        onClick={handlerOnClick}
        onPressBackButton={onPressBackButton}
      />
    </>
  );
};
